export interface ITableData {
  items: ITableItem[];
  rows: string[];
  type: PARAMETER_TYPE;
}

export interface ITableItem {
  idPoint?: number;
  name: string;
  pointDirection?: string | null;
  unitCode?: number | null;
  unitCode2?: number | null;
  values: Array<number | null>;
  values2?: Array<number | null>;
}

export enum PARAMETER_TYPE {
  point = "point",
  keyphasor = "keyphasor",
  parameter = "parameter",
  noGroup = "noGroup",
}
